export const COLUMN_WIDTHS = {
  CHECKBOX: 60,
  SMALL: 80,
  MEDIUM: 100,
  LARGE: 120,
  EXTRA_LARGE: 150,
  WIDE: 200,
  EXTRA_WIDE: 250,
  
  // Specific column types
  ICON: 70,
  DATE: 120,
  PRICE: 100,
  TIME: 100,
  TEXT: 120,
  ID: 80,
  STATUS: 100,
  ACTION: 60,
};
